import React from 'react';

interface FlagIconProps {
  code: 'en' | 'es' | 'pt';
  className?: string;
}

export function FlagIcon({ code, className = 'w-6 h-6' }: FlagIconProps) {
  if (code === 'en') {
    // UK Flag
    return (
      <svg viewBox="0 0 60 30" className={className}>
        <rect width="60" height="30" fill="#012169"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#fff" strokeWidth="6"/>
        <path d="M0,0 L60,30 M60,0 L0,30" stroke="#C8102E" strokeWidth="4"/>
        <path d="M30,0 v30 M0,15 h60" stroke="#fff" strokeWidth="10"/>
        <path d="M30,0 v30 M0,15 h60" stroke="#C8102E" strokeWidth="6"/>
      </svg>
    );
  }

  if (code === 'es') {
    // Spain Flag - horizontal stripes
    return (
      <svg viewBox="0 0 60 40" className={className}>
        <rect width="60" height="40" fill="#AA151B"/>
        <rect width="60" height="20" y="10" fill="#F1BF00"/>
      </svg>
    );
  }

  if (code === 'pt') {
    // Brazil Flag - simplified
    return (
      <svg viewBox="0 0 60 40" className={className}>
        <rect width="60" height="40" fill="#009b3a"/>
        <path d="M30,5 L55,20 L30,35 L5,20 Z" fill="#fedf00"/>
        <circle cx="30" cy="20" r="7" fill="#002776"/>
        <path d="M25,18 Q30,24 35,18" fill="none" stroke="#fff" strokeWidth="1"/>
      </svg>
    );
  }

  return null;
}